export enum ProxyMode {
  FIXED = 'FIXED',
  ELASTIC = 'ELASTIC',
}
